// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3mO2S","title":"BackImages_title__2Kpoz","images":"BackImages_images__3d9s5"};